"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsProcessing = void 0;
const react_1 = require("react");
const useIsProcessing = () => {
    const isProcessing = (0, react_1.useRef)(false);
    const [canLeaf, setCanLeaf] = (0, react_1.useState)(true);
    const setIsProcessing = (value) => {
        isProcessing.current = value;
        setCanLeaf(!value);
    };
    return { setIsProcessing, isProcessing, canLeaf };
};
exports.useIsProcessing = useIsProcessing;
